import { useMemo } from "react";

import { Message } from "../types/message";
import { formatLocalizedTimeAgo } from "../../../utils/formatDate";
import { isToday, format } from "date-fns";
import { ar, enUS } from "date-fns/locale";

interface MessageGroup {
  date: string;
  timestamp: Date;
  messages: Message[];
}

export const useMessageGroups = (messages: Message[], locale: string = "en") => {
  return useMemo(() => {
    const groups: MessageGroup[] = [];

    messages.forEach((message) => {
      const msgDate = new Date(message.createdAt || "");
      const msgDay = msgDate.toDateString();
      const dateLocale = locale === "ar" ? ar : enUS;

      let msgDayFormatted;
      if (isToday(msgDate)) {
        msgDayFormatted = locale === "ar" ? "اليوم" : "Today";
      } else {
        msgDayFormatted = formatLocalizedTimeAgo(msgDay, locale);
      }

      const lastGroup = groups[groups.length - 1];

      if (lastGroup && new Date(lastGroup.timestamp).toDateString() === msgDay) {
        lastGroup.messages.push(message);
      } else {
        groups.push({
          timestamp: msgDate,
          date: msgDayFormatted,
          messages: [message],
        });
      }
    });

    return groups;
  }, [messages, locale]);
};
